import config from "../Config/config";
import { fetchCategories } from "./categoryController";

const saveSubactivityCsv = async (
  cleanRow,
  tempResults,
  setPreviewOpen,
  refresh
) => {
  try {
    const res = await fetch(`${config.serverBaseUrl}/subactivity`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(cleanRow),
    });

    const message = res.ok
      ? "✅ Successfully uploaded"
      : `❌ ${res.status}: ${await res.text()}`;

    tempResults.push({ row: cleanRow, success: res.ok, message });
    setPreviewOpen(false);
    refresh();
  } catch (err) {
    tempResults.push({
      row: cleanRow,
      success: false,
      message: `❌ ${err.message}`,
    });
    setPreviewOpen(false);
  }
};

const saveSubactivity = async (
  selectedSubactivity,
  setIsEditingSub,
  setAlert,
  setCategories
) => {
  const method = selectedSubactivity.subactivity_id ? "PUT" : "POST";
  const url = selectedSubactivity.subactivity_id
    ? `${config.serverBaseUrl}/subactivity/${selectedSubactivity.subactivity_id}`
    : `${config.serverBaseUrl}/subactivity`;

  try {
    const response = await fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(selectedSubactivity),
    });

    if (response.ok) {
      setIsEditingSub(false);
      fetchCategories(setCategories);
      setAlert({
        severity: "success",
        message: `Subactivity saved!`,
      });
    } else {
      const data = await response.json();
      const error = data.error;
      setAlert({
        severity: "error",
        message: `Failed to save the subactivity: ${error}`,
      });
    }
  } catch (error) {
    setAlert({
      severity: "error",
      message: `Failed to save the subactivity: ${error}`,
    });
  }
};

const deleteSubactivity = async (id, setAlert, setCategories) => {
  const confirm = window.confirm("Delete this subactivity?");
  if (!confirm) return;

  try {
    const response = await fetch(`${config.serverBaseUrl}/subactivity/${id}`, {
      method: "DELETE",
      credentials: "include",
    });
    if (response.ok) {
      fetchCategories(setCategories);
      setAlert({
        severity: "success",
        message: `Subactivity deleted!`,
      });
    } else {
      const data = await response.json();
      const error = data.error;
      setAlert({
        severity: "error",
        message: `Failed to delete the subactivity: ${error}`,
      });
    }
  } catch (error) {
    setAlert({
      severity: "error",
      message: `Failed to delete the subactivity: ${error}`,
    });
  }
};

export { saveSubactivity, saveSubactivityCsv, deleteSubactivity };
